module.exports = __webpack_public_path__ + "img/banner2.b6522e28.png";